export function getEnvName(env) {
    return {
        prod: "Production",
        int: "Integration",
        stage: "Stage",
    }[env];
}
